/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateQuestionDto
 */
export interface CreateUpdateQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    surveyId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateQuestionDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    questionEn: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    responseType: CreateUpdateQuestionDtoResponseTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateQuestionDto
     */
    optional: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateQuestionDto
     */
    expectedYesNoAnswer?: CreateUpdateQuestionDtoExpectedYesNoAnswerEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateQuestionDto
     */
    blockOnWrongAnswer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateQuestionDto
     */
    warningLight: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateQuestionDto
     */
    active: boolean;
}


/**
 * @export
 */
export const CreateUpdateQuestionDtoResponseTypeEnum = {
    Text: 'Text',
    YesNo: 'YesNo',
    YesNoText: 'YesNoText'
} as const;
export type CreateUpdateQuestionDtoResponseTypeEnum = typeof CreateUpdateQuestionDtoResponseTypeEnum[keyof typeof CreateUpdateQuestionDtoResponseTypeEnum];

/**
 * @export
 */
export const CreateUpdateQuestionDtoExpectedYesNoAnswerEnum = {
    Yes: 'Yes',
    No: 'No'
} as const;
export type CreateUpdateQuestionDtoExpectedYesNoAnswerEnum = typeof CreateUpdateQuestionDtoExpectedYesNoAnswerEnum[keyof typeof CreateUpdateQuestionDtoExpectedYesNoAnswerEnum];


/**
 * Check if a given object implements the CreateUpdateQuestionDto interface.
 */
export function instanceOfCreateUpdateQuestionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "surveyId" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "questionEn" in value;
    isInstance = isInstance && "responseType" in value;
    isInstance = isInstance && "optional" in value;
    isInstance = isInstance && "blockOnWrongAnswer" in value;
    isInstance = isInstance && "warningLight" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateQuestionDtoFromJSON(json: any): CreateUpdateQuestionDto {
    return CreateUpdateQuestionDtoFromJSONTyped(json, false);
}

export function CreateUpdateQuestionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateQuestionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'surveyId': json['surveyId'],
        'order': json['order'],
        'question': json['question'],
        'questionEn': json['questionEn'],
        'responseType': json['responseType'],
        'optional': json['optional'],
        'expectedYesNoAnswer': !exists(json, 'expectedYesNoAnswer') ? undefined : json['expectedYesNoAnswer'],
        'blockOnWrongAnswer': json['blockOnWrongAnswer'],
        'warningLight': json['warningLight'],
        'active': json['active'],
    };
}

export function CreateUpdateQuestionDtoToJSON(value?: CreateUpdateQuestionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'surveyId': value.surveyId,
        'order': value.order,
        'question': value.question,
        'questionEn': value.questionEn,
        'responseType': value.responseType,
        'optional': value.optional,
        'expectedYesNoAnswer': value.expectedYesNoAnswer,
        'blockOnWrongAnswer': value.blockOnWrongAnswer,
        'warningLight': value.warningLight,
        'active': value.active,
    };
}

